import { ApiParameter, get } from "@insite/client-framework/Services/ApiService";

export interface AttributeTypes {
    attributeTypeFacets: AttributeTypeFacet[];
}

export interface AttributeTypeFacet {
    attributeTypeId: string;
    name: string;
    nameDisplay: string;
    sortOrder: number;
    attributeValueFacets: AttributeValueFacet[];
}

export interface AttributeValueFacet {
    attributeValueId: string;
    value: string;
    valueDisplay: string;
    count: number;
    sortOrder: number;
    selected: boolean;
}

export interface AttributeTypeParams extends ApiParameter {
    params: string;
}

const apiUrl = "/api/v2/attribute/getAttributeValuesByType";

export async function getAttributeValues(paramater: AttributeTypeParams) {
    const response = await get<AttributeTypes>(`${apiUrl}?attributeType=${paramater.params}`);
    return response;
}
